import { Input, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import * as S from './style';

function ColumnInput({ isFocused, readOnly, error, columnProps, ...props }) {
  const [input, setInput] = useState();

  const isErrorFocus = columnProps?.componentProps?.isValidInput
    ? !columnProps.componentProps.isValidInput(props?.value)
    : false;

  const isInputShown = !readOnly && (isFocused || isErrorFocus || !props.value);

  useEffect(() => {
    if (isFocused && input) {
      input?.focus();
    }
  }, [input, isFocused]);

  return (
    <S.ColumnInputWrapper
      onClick={() => {
        if (!readOnly) props.onFocus();
      }}
    >
      {isInputShown ? (
        <>
          <Input
            ref={input => {
              setInput(input);
            }}
            error={error}
            {...props}
            {...(columnProps?.componentProps || {})}
            onKeyDown={event => {
              if (event.key === 'Enter') {
                props.onBlur(event);
              }
            }}
            onChange={e => {
              if (props.type === 'number' && e.target.value) {
                if (columnProps?.componentProps?.min && columnProps?.componentProps?.max) {
                  const newValue = parseInt(e.target.value, 0);
                  if (
                    newValue >= columnProps?.componentProps?.min &&
                    newValue <= columnProps?.componentProps?.max
                  ) {
                    props.onChange(e, e.target.value);
                  }
                }
              } else {
                props.onChange(e, e.target.value);
              }
            }}
          />
          {/* {error && (
            <S.ColumnInputErrorWrapper>
              <Icon name="error" size="md" color="var(--color-error-default)" />
              <Typography variant="body2" color="error">
                {columnProps?.errorMessage}
              </Typography>
            </S.ColumnInputErrorWrapper>
          )} */}
        </>
      ) : (
        <Typography variant="body2" lineClamp={1}>
          {props.value}
        </Typography>
      )}
    </S.ColumnInputWrapper>
  );
}

ColumnInput.S = S;

ColumnInput.propTypes = {
  isFocused: PropTypes.bool,
  readOnly: PropTypes.bool,
  error: PropTypes.bool,
  props: PropTypes.shape({
    onFocus: PropTypes.func,
    value: PropTypes.string
  }),
  columnProps: PropTypes.shape({
    errorMessage: PropTypes.string
  })
};

export { ColumnInput };
